// extracted by mini-css-extract-plugin
module.exports = {"container":"BillPrintDrawer_container__2ZVDX","addBtn":"BillPrintDrawer_addBtn__2vVcN"};